import React, { useState } from "react";
import Swal from "sweetalert2";
import { actualizarRatificacion } from "../../utils/Datos";
import { ahora, hoy } from "../../utils/Util";
import { FormularioCalificacion } from "../EtapasDeCalificacion/FormularioCalificacion";
import { FormularioCalificacionEditable } from "../EtapasDeCalificacion/FormularioCalificacionEditable";

export const ModalActualizarCalificacion = ({
  id_participant,
  setActualizar,
}) => {
  const [cargando, setCargando] = useState(false);

  const handleActualizarRatificacion = () => {
    setCargando(true);
    const $ = window.jQuery;
    const payload = {};
    actualizarRatificacion(payload).then((respuesta) => {
      if (respuesta === true) {
        $("#modal").modal("hide");
        Swal.fire({
          title: "Listo",
          text: "Sesión iniciada",
          icon: "success",
          confirmButtonText: "Ok",
        });
        setActualizar(true);
      } else {
        Swal.fire({
          title: "Error",
          text: "Ocurrió un error al iniciar la sesión",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargando(false);
    });
  };

  const fechaHoy = hoy();
  const hora = ahora();

  return (
    <div
      className="modal fade"
      id="modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Editar</h5>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span className="svg-icon svg-icon-1 ">X</span>
            </div>
          </div>
          <div className="modal-body">
            <FormularioCalificacionEditable   id_participant={id_participant}>

            </FormularioCalificacionEditable>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              disabled={cargando}
            >
              Cerrar
            </button>
            
          </div>
        </div>
      </div>
    </div>
  );
};
